<astrea-internal-banner
    title="{{ 'footer.policy' | translate }}"
></astrea-internal-banner>

<div class="astrea-policy content-height p-4">
    <div class="container">

        <div>
            <div class="astrea-subtitle">
                <h2>1. Protección de Datos</h2>
            </div>
            <p>
                En Astrea reconocemos la importancia de la protección de los datos personales y nos comprometemos a
                garantizar la privacidad de los usuarios de nuestro sitio web (www.astrea.com.ar). Esta política
                describe cómo recopilamos, utilizamos, almacenamos y protegemos la información brindada por los
                usuarios al utilizar nuestros servicios, conforme a la normativa vigente en materia de protección de
                datos personales.
            </p>
        </div>

        <div>
            <div class="astrea-subtitle">
                <h2>2. Información recopilada</h2>
            </div>
            <p>
                Al registrarse o realizar una compra en nuestro sitio, el usuario proporciona datos personales
                indispensables para procesar su pedido y brindar un servicio adecuado. Entre ellos se encuentran:
                nombre, apellido, dirección de correo electrónico, domicilio, número de documento o CUIT, entre
                otros. En algunos casos, el usuario también puede brindar voluntariamente información relacionada
                con su perfil académico o profesional.
            </p>
        </div>

        <div>
            <div class="astrea-subtitle">
                <h2>3. Finalidad del uso de los datos</h2>
            </div>
            <p>
                Los datos personales recopilados son utilizados con fines exclusivamente relacionados con la gestión
                de compras, la facturación, el despacho de productos y el contacto con el cliente ante cualquier
                inconveniente. Astrea podrá utilizar dichos datos también para mantener un registro interno de
                usuarios y mejorar la calidad del servicio ofrecido. Bajo ninguna circunstancia se venderán,
                intercambiarán ni compartirán estos datos con terceros, salvo cuando sea necesario para cumplir con
                obligaciones legales o logísticas (como servicios de mensajería).
            </p>
        </div>

        <div>
            <div class="astrea-subtitle">
                <h2>4. Seguridad de la información</h2>
            </div>
            <p>
                Astrea adopta todas las medidas técnicas y organizativas razonables para garantizar la seguridad y
                confidencialidad de los datos personales. Nuestro sitio cuenta con protocolos de conexión segura
                (SSL), asegurando que toda la información transmitida entre el navegador del usuario y nuestros
                servidores viaje cifrada y protegida contra accesos no autorizados. Además, trabajamos con
                plataformas de pago externas que garantizan el resguardo de los datos financieros, sin que estos
                sean almacenados por Astrea.
            </p>
        </div>

        <div>
            <div class="astrea-subtitle">
                <h2>5. Uso de herramientas de análisis</h2>
            </div>
            <p>
                Este sitio utiliza Google Analytics como herramienta para el análisis del comportamiento de
                navegación de los usuarios, con el objetivo de mejorar la experiencia general del sitio. La
                información recopilada es anónima y no permite identificar personalmente al usuario. Astrea no hace
                uso de cookies adicionales ni tecnologías de seguimiento con fines publicitarios.
            </p>
        </div>

        <div>
            <div class="astrea-subtitle">
                <h2>6. Consultas y derechos del usuario</h2>
            </div>
            <p>
                El usuario tiene derecho a acceder, rectificar, actualizar o suprimir sus datos personales
                almacenados en nuestra base. Para ejercer estos derechos o realizar cualquier consulta sobre nuestra
                política de privacidad, podrá contactarse mediante los canales de atención disponibles en el sitio
                web. Astrea responderá a todas las solicitudes en tiempo y forma, conforme a lo establecido por la
                legislación vigente.
            </p>
        </div>

    </div>
</div>
